import React, { ReactElement } from 'react';
import { Popover } from '@gafe/common-ui';

import styles from './WarningPopOver.module.scss';

type Props = {
  children: ReactElement;
  productErrors: string[];
};

export const WarningPopOver = ({ children, productErrors }: Props) => {
  return (
    <Popover
      classes={{
        title: styles.popover_title,
        popover: styles.popover,
      }}
      hidden={productErrors.length === 0}
      text={
        <div className={styles.warning_wrapper}>
          <div className={styles.message_wrapper}>
            {productErrors.map((error, index) => error && <li key={index}>{error}</li>)}
          </div>
        </div>
      }
      title="Please complete missing fields"
      type="warning"
    >
      {children}
    </Popover>
  );
};
